var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 1.25H12.9C8.99 1.25 7.25 2.99 7.25 6.9V8C7.25 8.41 7.59 8.75 8 8.75H11.1C14.2 8.75 15.25 9.8 15.25 12.9V16C15.25 16.41 15.59 16.75 16 16.75H17.1C21.01 16.75 22.75 15.01 22.75 11.1V6.9C22.75 2.99 21.01 1.25 17.1 1.25ZM8.75 7.25V6.9C8.75 3.8 9.8 2.75 12.9 2.75H17.1C20.2 2.75 21.25 3.8 21.25 6.9V11.1C21.25 14.2 20.2 15.25 17.1 15.25H16.75V12.9C16.75 8.99 15.01 7.25 11.1 7.25H8.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 7.25H6.9C2.99 7.25 1.25 8.99 1.25 12.9V17.1C1.25 21.01 2.99 22.75 6.9 22.75H11.1C15.01 22.75 16.75 21.01 16.75 17.1V12.9C16.75 8.99 15.01 7.25 11.1 7.25ZM6.9 21.25C3.8 21.25 2.75 20.2 2.75 17.1V12.9C2.75 9.8 3.8 8.75 6.9 8.75H11.1C14.2 8.75 15.25 9.8 15.25 12.9V17.1C15.25 20.2 14.2 21.25 11.1 21.25H6.9Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03002 17.7C7.84002 17.7 7.65002 17.63 7.50002 17.48L5.55002 15.53C5.26002 15.24 5.26002 14.76 5.55002 14.47C5.84002 14.18 6.32002 14.18 6.61002 14.47L8.03002 15.89L11.39 12.53C11.68 12.24 12.16 12.24 12.45 12.53C12.74 12.82 12.74 13.3 12.45 13.59L8.55002 17.48C8.41002 17.62 8.22002 17.7 8.03002 17.7Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.070b910e6c943d98c1c51954c4b1e9c6.svg";
export { ForwardRef as ReactComponent };